<template>

  <CmorGiornaliere />

</template>

<script>
import CmorGiornaliere from '../components/pratiche/CmorGiornaliere.vue'

export default {
  pageName: 'CmorGiornaliere',
  components: {
    CmorGiornaliere

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
